var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vsm-status-row-actions"},[_c('vsm-reload-button',{on:{"click":function($event){return _vm.$emit('reload')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }